module.exports = __webpack_public_path__ + "img/award_icon_red.83603a1c.png";